import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";
import { SubAccountTreasuredAssetsClient } from "../../../../../../../../Wrap/Api/Account/SubAccountTreasuredAssets";
import { FlatChargesClient } from "../../../../../../../../Wrap/Api/Charge/FlatCharges";
import { FundsDiscretePerformanceClient } from "../../../../../../../../Wrap/Api/Instruments/FundsDiscretePerformance";
import { SDRLabelClient } from "../../../../../../../../Wrap/Api/Instruments/SDRLabel";
import { SCFDDocClient } from "../../../../../../../../Wrap/Api/Instruments/SCFDDoc";
import { WebTemplatesClient } from "../../../../../../../../Wrap/Api/Common/WebTemplates";
import { FinexDocumentLocationClient } from "../../../../../../../../Wrap/Api/PortfolioAnalysis/Investment/FinexDocumentLocation";
import { InstrumentClient } from "../../../../../../../../Wrap/Api/PortfolioAnalysis/Investment/Instrument";
import { InstrumentValuationDistributionClient } from "../../../../../../../../Wrap/Api/PortfolioAnalysis/Investment/InstrumentValuationDistribution";
import { PortfolioInvestmentClient } from "../../../../../../../../Wrap/Api/PortfolioAnalysis/Investment/PortfolioInvestment";
import { ProductModelPortfolioInvestmentClient } from "../../../../../../../../Wrap/Api/PortfolioAnalysis/Investment/ProductModelPortfolioInvestment";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { Frequency } from "../../../../../../../../Wrap/Constants/Enums/Domain/Frequency";
import { AssetClassType } from "../../../../../../../../Wrap/Constants/Enums/Domain/Instrument/AssetClassType";
import { ViewType } from "../../../../../../../../Wrap/Mapping/PortfolioAnalysis/Investment/Enum/ViewType";
import { SDRLabelQuery } from "../../../../../../../../Wrap/Models/Domains/Investment/SDRLabelQuery";
import { SdrLabelModel } from "../../../../../../../../Wrap/Models/Models/Instruments/SdrLabelModel";
import { InstrumentSearchQuery } from "../../../../../../../../Wrap/Models/Domains/Investment/InstrumentSearchQuery";
import { InvestmentAllocation } from "../../../../../../../../Wrap/Models/Domains/Investment/InvestmentAllocation";
import { FlatCharge } from "../../../../../../../../Wrap/Models/Models/Charges/FlatCharge";
import { SCFDDocQuery } from "../../../../../../../../Wrap/Models/Domains/Investment/SCFDDocQuery";
import { ScfdDocModel } from "../../../../../../../../Wrap/Models/Models/Instruments/ScfdDocModel";
import { WebTemplatesModel } from "../../../../../../../../Wrap/Models/Models/Common/WebTemplatesModel";
import { AssetClassInstrumentWeighting } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/AssetClassInstrumentWeighting";
import { FundPerformanceHistory } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/FundPerformanceHistory";
import { Instrument } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/Instrument";
import { Investment } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/Investment";
import { InvestmentGroup } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/InvestmentGroup";
import { ProductInvestment } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/ProductInvestment";
import { ValuationPoint } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/ValuationPoint";
import { IJsonDate } from "../../../../../../../../Wrap/System/IJsonDate";
import { InvestmentSelectionAction } from "../../../../../../../Shared/IST/Action/InvestmentSelectionAction";
import { TreasuredAssetsDispatcher } from "../../../../../../Stroes/Variable";
import {
    IInvestmentGroup,
    IInvestmentTableData,
    IProductTableData,
    IHoldingsData,
    IInvestmentWithToggle,
} from "../Store/InvestmentsStatic";
import {
    InvestmentsDispatcher,
    ModelUnderlyingInvestmentsDispatcher,
    ModelUnderlyingInvestmentsStore,
} from "../Store/Variable";
import { Instrument as InvestmentInstrument } from "../../../../../../../../Wrap/Models/Domains/Investment/Instrument";

export class InvestmentsAction {
    public static getInvestments(
        hierarchyIds: string[],
        asAt: IJsonDate,
        assetClassType: AssetClassType,
        viewType: ViewType,
        callback?: (val: ProductInvestment[]) => void
    ): void {
        const _self = this;
        const client = new PortfolioInvestmentClient();
        const promise = client.get(hierarchyIds, assetClassType, asAt, viewType);

        promise.onSuccess((result) => {
            //calculate total
            const data = this.getInvestmentData(result);
            InvestmentsDispatcher.dispatch({ actionType: ActionType.Success, payload: data });
            if (callback) {callback(result);}
        });

        promise.onError((err) => {
            InvestmentsDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }
    public static getInvestmentsModel(
        modelFundInstrumentCodes: Array<string>,
        asAt: IJsonDate,
        assetClassType: AssetClassType,
        index: number,
        product: number,
        callback?: (val: InvestmentGroup[]) => void,
        modelId?: string
    ): void {
        const _self = this;
        const client = new ProductModelPortfolioInvestmentClient();
        const promise = client.get(modelFundInstrumentCodes, asAt, assetClassType);

        // reset store
        ModelUnderlyingInvestmentsStore.resetData();

        promise.onSuccess((result) => {
            const modelInvestments: IInvestmentGroup[] = result.map((ele) => {
                return {
                    AssetClass: ele.AssetClass,
                    Investments: _self.addToggle(ele.Investments, []),
                    total: _self.getTotal(ele.Investments),
                };
            });
            modelInvestments.forEach((investment) =>
                investment.Investments.sort((a, b) => a.DisplayName.localeCompare(b.DisplayName))
            );
            ModelUnderlyingInvestmentsDispatcher.dispatch({
                actionType: ActionType.Success,
                isLoading: false,
                payload: {
                    instrumentCode: modelId || modelFundInstrumentCodes[0],
                    index: index,
                    product: product,
                    underlyings: modelInvestments,
                },
            });

            callback(result);
        });

        promise.onError((err) => {
            InvestmentsDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static getInvestmentsModelSingle(
        hierarchyId: string,
        modelFundInstrumentCode: string,
        asAt: IJsonDate,
        assetClassType: AssetClassType,
        callback?: (val: InvestmentGroup[]) => void
    ): void {
        const client = new ProductModelPortfolioInvestmentClient();
        const promise = client.get([modelFundInstrumentCode.toString()], asAt, assetClassType);

        promise.onSuccess((result) => {
            callback(result);
        });
    }

    public static getInvestmentData(result: ProductInvestment[]): IInvestmentTableData {
        const _self = this;
        const data: IInvestmentTableData = { data: [], total: _self.initTotal() };
        result.forEach((account) => {
            const weighting = account.InstrumentWeighting;
            const { IndividualInvestments, OffPlatformInvestments, ModelPortfolioInvestments, ...rest } = account;
            const IndividualInvestmentsGet = _self.getHolding(account.IndividualInvestments, weighting);
            const OffPlatformInvestmentsGet = _self.getHolding(account.OffPlatformInvestments, weighting);
            const ModelPortfolioInvestmentsGet = _self.getHolding(account.ModelPortfolioInvestments, weighting);
            const total = _self.getTotal([
                IndividualInvestmentsGet.total,
                OffPlatformInvestmentsGet.total,
                ModelPortfolioInvestmentsGet.total,
            ]);

            IndividualInvestmentsGet.data.forEach((investment) =>
                investment.Investments.sort((a, b) => a.DisplayName.localeCompare(b.DisplayName))
            );

            ModelPortfolioInvestmentsGet.data.forEach((investment) =>
                investment.Investments.sort((a, b) => a.DisplayName.localeCompare(b.DisplayName))
            );

            OffPlatformInvestmentsGet.data.forEach((investment) =>
                investment.Investments.sort((a, b) => a.DisplayName.localeCompare(b.DisplayName))
            );
            const product: IProductTableData = {
                IndividualInvestments: IndividualInvestmentsGet,
                OffPlatformInvestments: OffPlatformInvestmentsGet,
                ModelPortfolioInvestments: ModelPortfolioInvestmentsGet,
                total: total,
                EditTreasureAssets: account.TreasuredAssets.concat(),
                TreasuredAssets: account.TreasuredAssets,
                RingfencedInstruments: account.RingfencedInstruments,
                ...rest,
            };
            data.data.push(product);
            data.total = _self.getTotal([data.total, total]);
        });
        data.data.sort((a, b) => a.ClAccountId.localeCompare(b.ClAccountId));
        data.data.push(
            data.data.splice(data.data.indexOf(data.data.filter((a) => a.ProductDisplayName == "Wrap Cash")[0]), 1)[0]
        );
        return data;
    }

    private static getHolding(data: InvestmentGroup[], weight: AssetClassInstrumentWeighting[]): IHoldingsData {
        const _self = this;
        const holding: IHoldingsData = {
            data: [],
            total: _self.initTotal(),
        };
        data.forEach((asset) => {
            const investments: IInvestmentGroup = {
                AssetClass: asset.AssetClass,
                Investments: _self.addToggle(asset.Investments, weight),
                total: _self.getTotal(asset.Investments),
            };
            holding.data.push(investments);
            holding.total = _self.getTotal([_self.getTotal(asset.Investments), holding.total]);
        });
        return holding;
    }

    private static addToggle(
        data: Investment[],
        InstrumentWeighting: AssetClassInstrumentWeighting[]
    ): IInvestmentWithToggle[] {
        return data.map((ele) => {
            const filterObj = InstrumentWeighting.filter((weight) => weight.InstrumentCode === ele.InstrumentCode);
            const weight = filterObj && filterObj.length > 0 ? filterObj[0].Weighting : 0;
            return { sub: null, ...ele, InstrumentWeighting: weight };
        });
    }

    private static initTotal() {
        return {
            Difference: { Amount: 0, Currency: CurrencyCode.GBP },
            Allocation: 0,
            TotalCost: { Amount: 0, Currency: CurrencyCode.GBP },
            MarketValue: { Amount: 0, Currency: CurrencyCode.GBP },
            InstrumentWeight: 0,
        };
    }

    private static getTotal(data: any[]) {
        const total = this.initTotal();
        data.forEach((ele) => {
            total.Difference.Amount += ele.Difference.Amount;
            total.Allocation += ele.Allocation;
            total.TotalCost.Amount += ele.TotalCost.Amount;
            total.MarketValue.Amount += ele.MarketValue.Amount;
            total.InstrumentWeight += ele.InstrumentWeight;
        });
        return total;
    }

    public static getInstrumentDetails(instrumentCode: string, callback: (val: Instrument) => void): void {
        const client = new InstrumentClient();
        const promise = client.get(instrumentCode);
        promise.onSuccess((result) => {
            callback(result);
        });
    }

    public static getInstrumentDiscretePerformanceDetails(
        productId: number,
        callback: (val: Array<FundPerformanceHistory>) => void
    ): void {
        const client = new FundsDiscretePerformanceClient();
        const promise = client.get(productId);
        promise.onSuccess((result) => {
            callback(result);
        });
    }

    public static getConsumerFacingDisclosure(
        productId: number,
        callback: (val: SdrLabelModel[]) => void
    ): void {
        const client = new SDRLabelClient();
        const query: SDRLabelQuery = { instrumentIds: [productId] };
        const promise = client.post(query);
        
        promise.onSuccess((result) => {
            callback(result);
        });
    }

    public static getSCFDUrl(
        productId: number,
        callback: (val: ScfdDocModel[]) => void
    ): void {
        const client = new SCFDDocClient();
        const query: SCFDDocQuery = { instrumentIds: [productId] };
        const promise = client.post(query);
        
        promise.onSuccess((result) => {
            callback(result);
        });
    }

    public static getNonUKDomicileMessage(
        callback: (val: WebTemplatesModel) => void
    ): void {
        const templateName = 'NonUKDomicileMessage';
        const client = new WebTemplatesClient();
        const promise = client.get(templateName); 
    
        promise.onSuccess((res: WebTemplatesModel) => {
            callback(res);
        });
    }

    public static getFinexDocument(citicode: string, callback?: (val: string) => void): void {
        const client = new FinexDocumentLocationClient();
        const promose = client.get(citicode);
        promose.onSuccess((result) => {
            callback(result);
        });
    }

    public static getInstrumentValuationDistribution(
        investmentCode: string,
        from: IJsonDate,
        to: IJsonDate,
        frequency: Frequency,
        currentpage: number,
        resultsPerpage: number,
        callback: (val: ValuationPoint[]) => void
    ): void {
        const client = new InstrumentValuationDistributionClient();
        const promise = client.get(investmentCode, from, to, frequency, currentpage, resultsPerpage);
        promise.onSuccess((result) => {
            callback(result.Results);
        });
    }

    public static setSubAccountTreasuredAssetsProductIds(
        hierarchyId: string,
        treasuredProductIds: Array<number>,
        callBack?: () => void
    ): void {
        const client = new SubAccountTreasuredAssetsClient();
        const promise = client.put(hierarchyId, treasuredProductIds);

        TreasuredAssetsDispatcher.dispatch({ actionType: ActionType.Loading });

        promise.onSuccess((result) => {
            if (callBack) {
                callBack();
            }

            TreasuredAssetsDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: treasuredProductIds,
            });
        });

        promise.onError((err) => {});
    }

    public static getFlatChargeStaticData(callback: (val: FlatCharge[]) => void): void {
        const client = new FlatChargesClient();
        const promise = client.get();
        promise.onSuccess((result) => {
            callback(result);
        });

        promise.onError((err) => {});
    }

    public static getAllocationAssetDetails(hierarchyId:string, buyAllocations: InvestmentAllocation[], sellAllocations: InvestmentAllocation[], callback?) {
        const productIds = [];
        if (buyAllocations && buyAllocations.length > 0) {
            buyAllocations.map(item => { productIds.push(item.ProductId) });
        }
        if (sellAllocations && sellAllocations.length > 0) {
            sellAllocations.map(item => { productIds.push(item.ProductId) });
        }
        if (productIds.length > 0) {
            this.getAssetDetails(productIds, hierarchyId, (result) => {
                if(callback) callback(result,buyAllocations,sellAllocations);
            })
        }
    }
    
    public static getAssetDetails = (productIds, hierarchyid, callback?) => {
        const query: InstrumentSearchQuery = {
            ProductIds: productIds,
        };
        InvestmentSelectionAction.searchInstruments(query, hierarchyid, (result: InvestmentInstrument[]) => {
            if (callback) callback(result);
        });
    };
}
